import DuelModal, { ModalBody, ModalFooter, ModalHeader } from '@duel/modal';
import * as React from 'react';

export interface IModalProps {
	className?: string;
	contentLabel?: string;
	header?: string | React.ReactNode;
	bodyInput?: any;
	formattedStringHeader?: any;
	body?: string;
	footerButtons?: any;
	show: boolean;
	onCancel(): void;
}

export default class Modal extends React.Component<IModalProps> {
	public render() {
		const {
			className,
			show,
			onCancel,
			header,
			body,
			bodyInput,
			footerButtons,
			contentLabel,
			formattedStringHeader,
		} = this.props;

		return (
			<DuelModal
				contentLabel={contentLabel}
				show={show}
				onCancel={onCancel}
				className={className}
			>
				<ModalHeader>
					{header}
					{formattedStringHeader}
				</ModalHeader>
				<ModalBody>
					{body}
					{bodyInput}
				</ModalBody>
				<ModalFooter>{footerButtons}</ModalFooter>
			</DuelModal>
		);
	}
}
